import _ from 'underscore';
import urijs from 'urijs';

export const Scope = {
  Customer: 0,
  Account: 1,
  Campaign: 2,
  AdGroup: 3,
  Ad: 4,
  PerformanceTarget: 5,
};

export const getCurrentScope = (currentCampaignId, currentAdGroupId, currentAccountId) => {
  if (currentAdGroupId) {
    return Scope.AdGroup;
  }

  if (currentCampaignId) {
    return Scope.Campaign;
  }

  if (currentAccountId) {
    return Scope.Account;
  }

  return Scope.Customer;
};

export const getCurrentScopeFromService = (scope) => {
  const values = (scope && scope.values) || {};
  const { aid, campaignId, adGroupId } = values;
  return getCurrentScope(campaignId, adGroupId, aid);
};

const SCOPE_TO_KEY = {
  [Scope.Account]: 'aid',
  [Scope.Campaign]: 'campaignId',
  [Scope.AdGroup]: 'adGroupId',
};

function trimScopeInternal({
  urlQuery,
  currentScope,
  leastSupportedScope,
}) {
  // i.e. currentScope = 1 = account scope
  // leastSupportedScope = 0 = customer scope
  if (currentScope > leastSupportedScope) {
    const queryToRemove = _.range(leastSupportedScope + 1, currentScope + 1)
      .map(scopeNumber => SCOPE_TO_KEY[scopeNumber]);

    return urijs(urlQuery).removeQuery(queryToRemove).toString();
  }

  // No need to trim scope, return url query as it is
  return urlQuery;
}

export function trimScope(supportedScopes, scopeService, siteMapId) {
  /* eslint-disable object-curly-newline */
  const { history, values: { uid, cid, aid, campaignId, adGroupId } } = scopeService;
  if (siteMapId === 'import-google' || siteMapId === 'import-file') {
    return scopeService.stringify(_.omit({
      uid,
      cid,
      aid,
    }, value => !value));
  }

  const currentScope = getCurrentScope(campaignId, adGroupId, aid);
  const leastSupportedScope = _.isEmpty(supportedScopes) ? Scope.Account : _.max(supportedScopes);

  return trimScopeInternal({
    urlQuery: history.location.search,
    currentScope,
    leastSupportedScope,
  });
}
